import { MinimalAudioSkinElement } from '../../presets/audio/minimal-skin';
import { safeDefine } from '../../registration/safe-define';
import './minimal-ui';

safeDefine(MinimalAudioSkinElement);
